<template>
  <div>
     <b-row>
      <b-col cols="2" style="padding-bottom: 1%">
        <b-button v-if="currentRow" variant="success" @click="showAddAccount">{{ $t('Add') }}</b-button>
      </b-col>
    </b-row>
    <b-table striped hover small
    :items="accountList"
    :fields="fields"
    @row-clicked="rowClickHandler"
    :per-page="perPage"
    :current-page="currentPage"
    selectable
    @row-selected="onRowSelected"
    select-mode="single">
      <template v-slot:cell(actions)="row">
        <b-button v-if="isShowPayment" size="sm" @click.stop="ClickOnPaymentButton(row)" variant="info">
          {{ $t('Payment') }}
        </b-button>
        <b-button size="sm" @click.stop="ClickOnDeleteAccountsButton(row)" id="transparent">
          <b-img :src='deleteDocumentImage' />
        </b-button>
      </template>
      <template slot="row-details" slot-scope="row">
        <div style="margin:1px">
          <Detail ref="Detail" :currentRow="row.item" @makeToasts="makeToasts" @refreshTable="refreshTable"/>
        </div>
      </template>
    </b-table>

    <b-modal ref="modalAddAccount" hide-footer @hidden="isShowAddAccount = false" @show="isShowAddAccount = true" :title="$t('New account')">
      <FormAddAccount @refreshTable="refreshTable" @hideAddAccount="hideAddAccount" @makeToasts="makeToasts" :currentRow="currentRow"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteAccounts">
      <h5>{{ $t('Are you sure you want to delete one of "Accounts"?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="deleteAccounts()">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideDeleteAccounts()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'
import Detail from '@/pages/users/accounts/detail/main'
import FormAddAccount from '@/pages/users/accounts/formAdd'

export default {
  components: {
    Detail,
    FormAddAccount
  },
  props: {
    filter: null,
    userId: null,
    isShowPayment: null,
    perPage: null,
    currentPage: null,
    currentRow: null
  },
  data () {
    return {
      accountId: null,
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      isShowAddAccount: false,
      accountList: [],
      userList: [],
      fields: [
        { key: 'account_id', label: this.$i18n.t('ID accounts'), sortable: true, sortDirection: 'desc' },
        { key: 'login', label: this.$i18n.t('Customer'), sortable: true, sortDirection: 'desc' },
        { key: 'balance', label: this.$i18n.t('Balance'), sortable: true, sortDirection: 'desc' },
        { key: 'credit', label: this.$i18n.t('Credit'), sortable: true },
        { key: 'active_block_name', label: this.$i18n.t('Block inet'), sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      totalRows: 0
    }
  },
  methods: {
    ClickOnDeleteAccountsButton (row) {
      this.accountId = row.item
      this.$refs.modalDeleteAccounts.show()
    },
    hideDeleteAccounts () {
      this.$refs.modalDeleteAccounts.hide()
    },
    deleteAccounts () {
      axiosInstance.delete(this.$store.getters.API_USERS_ACCOUNTS + '?account_id=' + this.accountId.account_id).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
          this.$refs.modalDeleteAccounts.hide()
          this.$emit('refreshTable')
        }
      })
    },
    showAddAccount () {
      this.isShowAddAccount = true
      this.$refs.modalAddAccount.show()
    },
    hideAddAccount () {
      this.isShowAddAccount = false
      this.$refs.modalAddAccount.hide()
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    refreshTable () {
      this.load()
      this.$emit('refreshTable')
    },
    onRowSelected (items) {
      for (let i in this.selected) {
        for (let j in items) {
          if (this.selected[i] === items[j]) {
            break
          }
        }
        this.selected[i]._showDetails = false
      }
      this.selected = items
      for (let i in this.selected) {
        this.selected[i]._showDetails = true
      }
    },
    rowClickHandler (record, index) {
      this.$emit('clickOnAccount', record)
    },
    ClickOnPaymentButton (row) {
      this.$emit('ClickOnPaymentButton', row.item)
    },
    load () {
      let userId = -1
      if (this.userId) {
        userId = this.userId
      } else if (this.currentRow) {
        userId = this.currentRow.user_id
      }

      if (userId !== -1) {
        axiosInstance.get(this.$store.getters.API_USERS_ACCOUNTS + '?user_id=' + userId).then(response => {
          var tempAccountList = response.data
          for (var i in tempAccountList) {
            var curAccount = tempAccountList[i]

            if (curAccount.active_block_id) {
              curAccount.active_block_name = 'Block'
              curAccount._cellVariants = {active_block_name: 'danger'}
            } else {
              curAccount.active_block_name = 'Active'
            }
            tempAccountList[i].balance = Number.parseFloat(tempAccountList[i].balance).toFixed(3)
            tempAccountList[i]._showDetails = false
          }
          this.accountList = tempAccountList
          this.$emit('input', this.accountList.length)
        })
      } else {
        let curFilter = ''
        if (this.filter) {
          curFilter = this.filter
        }
        axiosInstance.post(this.$store.getters.API_USERS_ACCOUNTS_SEARCH, { 'value': curFilter }).then(response => {
          this.accountList = response.data
          for (var i in this.accountList) {
            let curAccount = this.accountList[i]
            if (curAccount.active_block_id) {
              curAccount.active_block_name = 'Block'
              curAccount._cellVariants = {active_block_name: 'danger'}
            } else {
              curAccount.active_block_name = 'Active'
            }
            curAccount.balance = Number.parseFloat(curAccount.balance).toFixed(3)
          }
          this.$emit('input', this.accountList.length)
        })
      }
    }
  },
  watch: {
    currentRow: function (val) {
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/users/Accounts.vue